import { createApi } from '@reduxjs/toolkit/query/react';
import { customBaseQuery } from '@/lib/baseQuery';
import { ApiResponse } from '@/shared/types';

export const websiteOAApi = createApi({
  reducerPath: 'websiteOAApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getWebsitePurchaseRequestList: builder.query<
      ApiResponse<any>,
      {
        page: number;
        pageSize?: number;
        fieldFilters?: { key: string; value: string }[];
      }
    >({
      query: ({ page, pageSize = 10, fieldFilters }) => {
        const params: Record<string, any> = {
          _labels: '1',
          page_size: pageSize,
          current_page: page,
        };

        if (fieldFilters && fieldFilters.length > 0) {
          params.search = JSON.stringify({ field_filters: fieldFilters });
        }

        return {
          url: `v1/odin-web/purchase-assessment/list`,
          method: 'GET',
          params,
        };
      },
    }),

    getWebsiteRefinanceRequestList: builder.query<
      ApiResponse<any>,
      {
        page: number;
        pageSize?: number;
        fieldFilters?: { key: string; value: string }[];
      }
    >({
      query: ({ page, pageSize = 10, fieldFilters }) => {
        const params: Record<string, any> = {
          _labels: '1',
          page_size: pageSize,
          current_page: page,
        };

        if (fieldFilters && fieldFilters.length > 0) {
          params.search = JSON.stringify({ field_filters: fieldFilters });
        }

        return {
          url: `v1/odin-web/refinance-assessment/list`,
          method: 'GET',
          params,
        };
      },
    }),

    getAssessmentDetail: builder.query<
      ApiResponse<any>,
      { entryId: string; _labels?: boolean }
    >({
      query: ({ entryId, _labels = true }) => {
        return {
          url: `v1/odin-web/assessment/${entryId}`,
          method: 'GET',
          params: {
            _labels: _labels ? 'true' : 'false',
          },
        };
      },
    }),

    postGravityForm: builder.mutation<
      ApiResponse<any>,
      { formId: string; sheetId: string }
    >({
      query: (body) => ({
        url: 'v1/odin-web/gravity-forms',
        method: 'POST',
        body,
      }),
    }),
    getGravityFormById: builder.query<ApiResponse<any>, { formId: string }>({
      query: ({ formId }) => {
        return {
          url: `v1/odin-web/gravity-forms/by-form/${formId}`,
          method: 'GET',
        };
      },
    }),
  }),
});

export const {
  useGetWebsitePurchaseRequestListQuery,
  useGetWebsiteRefinanceRequestListQuery,
  useGetAssessmentDetailQuery,
  usePostGravityFormMutation,
  useGetGravityFormByIdQuery,
} = websiteOAApi;
